<template>
  <a-card :title="'用户数据统计' + today_dt">
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item label="国家代码">
          <a-input placeholder="Region" v-model:value="formSearch.region" />
        </a-form-item>
        <a-form-item>
          <a-button
            :loading="loading"
            type="primary"
            html-type="submit"
            @click="load()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
          
        </a-form-item>
      </a-form>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('')"
      >全球</a-button>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('CN')"
      >国内</a-button>
      <a-button
        :loading="loading"
        type="primary"
        @click="loadRegion('OVERSEA')"
      >海外</a-button>
    </a-space>
      <table class="stats-table">
        <legend>整体数据 <a-spin v-if="loading" /></legend>
        <tr>
          <th >项目</th><th>数据</th><th>公式</th><th>说明</th>
        </tr>
        <tr>
          <td >用户总数</td><td>{{ formatNumberWithCommas(stats_data.user_total_count) }}</td><td></td><td></td>
        </tr>
        <tr>
          <td>会员总数</td><td>{{ formatNumberWithCommas(stats_data.vip_total_count) }}</td><td></td><td>
            包括应用内购买会员、后台开通会员、终身会员等所有会员
          </td>
        </tr>
        <tr>
          <td>会员开通率</td><td>{{ (stats_data.vip_total_count / stats_data.user_total_count * 100 ).toFixed(2)}}%</td>
          <td>{{ stats_data.vip_total_count }} / {{ stats_data.user_total_count}}</td>
          <td></td>
        </tr>
        <tr>
          <td>当前有效会员总数</td><td>{{ formatNumberWithCommas(stats_data.vip_valid_total_count) }}</td><td></td><td>
            包括应用内购买会员、后台开通会员、终身会员等所有会员, 过期时间大于今天
          </td>
        </tr>
        <tr>
          <td>有效会员开通率</td><td>{{ (stats_data.vip_valid_total_count / stats_data.user_total_count * 100 ).toFixed(2)}}%</td>
          <td>{{ stats_data.vip_valid_total_count }} / {{ stats_data.user_total_count}}</td>
          <td></td>
        </tr>
        <tr>
          <td>总收入</td><td> {{ formatNumberWithCommas(stats_data.pay_total_amount.pay_amount / 100) }}¥</td><td></td>
          <td>系统内订单收入，不包含后台开通会员、终身会员。</td>
        </tr>
        <tr>
          <td>人均付费金额</td><td>  {{ (stats_data.pay_total_amount.pay_amount / 100 / stats_data.user_total_count ).toFixed(2) }}¥ </td>
          <td> {{ stats_data.pay_total_amount.pay_amount / 100 }} / {{ stats_data.user_total_count}}</td>
          <td></td>
        </tr>
        <tr>
          <td>付费人数</td><td> {{ stats_data.pay_user_total_count  }}</td><td></td>
          <td>系统内订单收入，不包含后台开通会员、终身会员。</td>
        </tr>
        <tr>
          <td>总付费率</td><td> {{ (stats_data.pay_user_total_count / stats_data.user_total_count * 100).toFixed(2)  }}% </td>
          <td>{{ stats_data.pay_user_total_count }} / {{stats_data.user_total_count  }}</td>
          <td></td>
        </tr>

      </table>
      <hr />
      <table class="stats-table">
        <legend>整体分端数据 <a-spin v-if="loading" /></legend>
        <tr>
          <th >项目</th><th>iOS</th><th>Android</th><th>说明</th>
        </tr>
        <tr>
          <td >用户总数</td>
          <td>{{ formatNumberWithCommas(stats_data.user_totals.ios) }}</td>
          <td>{{ formatNumberWithCommas(stats_data.user_totals.android) }}</td>
          <td>
            未知端用户: {{ stats_data.user_totals[""] }}
          </td>
        </tr>
        <tr>
          <td >付费总额</td>
          <td>{{ formatNumberWithCommas(stats_data.payment_sums.ios.pay_amount / 100) }}¥</td>
          <td>{{ formatNumberWithCommas(stats_data.payment_sums.android.pay_amount  / 100) }}¥</td><td>
            系统内订单收入，不包含后台开通会员、终身会员。
          </td>
        </tr>
        <tr>
          <td >付费用户总数</td>
          <td>{{ formatNumberWithCommas(stats_data.payment_user_totals.ios) }}</td>
          <td>{{ formatNumberWithCommas(stats_data.payment_user_totals.android) }}</td><td>
            系统内订单收入，不包含后台开通会员、终身会员。
          </td>
        </tr>
        <tr>
          <td >付费率</td>
          <td>{{ (100 * stats_data.payment_user_totals.ios / stats_data.user_totals.ios).toFixed(2) }}%</td>
          <td>{{ (100 * stats_data.payment_user_totals.android / stats_data.user_totals.android).toFixed(2) }}%</td>
          <td>
          </td>
        </tr>
        <tr>
          <td >人均付费金额</td><td>
            {{ (stats_data.payment_sums.ios.pay_amount / 100 / stats_data.payment_user_totals.ios).toFixed(2) }}¥
          </td>
          <td> 
            {{ (stats_data.payment_sums.android.pay_amount / 100  / stats_data.payment_user_totals.android).toFixed(2) }}¥
          </td>
          <td>
            系统内订单收入，不包含后台开通会员、终身会员。
          </td>
        </tr>

      </table>  
      <table class="stats-table">
        <legend>订单信息 <a-spin v-if="loading" /></legend>
        <tr>
          <th>付费方式</th>
          <th> 
             金额(¥)
          </th>
          <th>数量</th>
          <th>(系统内订单收入，不包含后台开通会员、终身会员)</th>
        </tr>
       
        <tr>
          <td> - 支付宝 </td>
          <td> 
            {{ (stats_data.total_order_sum.alipay.pay_amount/ 100).toFixed(2)  }}
          </td>
          <td>{{ stats_data.total_order_sum.alipay.total_count }}</td>
          <td></td>
        </tr>
       <tr>
          <td> - 微信 </td>
          <td> 
            {{ (stats_data.total_order_sum.wxpay.pay_amount / 100).toFixed(2) }} 
          </td>
          <td>{{ stats_data.total_order_sum.wxpay.total_count }}</td>
          <td></td>
        </tr>
        <tr>
          <td> - Apple </td>
          <td> 
            预估   {{ (stats_data.total_order_sum.apple.pay_amount / 100).toFixed(2) }} 
          </td>
          <td>{{ stats_data.total_order_sum.apple.total_count }}</td>
          <td></td>
        </tr>
        <tr>
          <td> - Google</td>
          <td> 
            预估  {{ (stats_data.total_order_sum.google.pay_amount / 100).toFixed(2) }}
          </td>
          <td>{{ stats_data.total_order_sum.google.total_count }}</td>
          <td></td>
        </tr>
      </table>
  </a-card>
</template>
<script>
import { defineComponent} from 'vue'
import request from '@/utils/request'
import { SearchOutlined } from '@ant-design/icons-vue';

function formatNumberWithCommas(num) {
  return new Intl.NumberFormat().format(num);
}

export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return {
      today_dt: today.toLocaleDateString(),
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',
      stats_data:{
        "total_order_sum": {
          "alipay": {},
          "apple": {},
          "google": {},
          "wxpay": {},
        },
        "user_total_count": 0,
        "vip_total_count": 0,
        "user_totals": {
          ios:{}, android:{}
        },
        "pay_user_total_count": 0,
        "payment_user_totals": {},
        "pay_total_amount": {},
        "payment_sums": {
          ios:{}, android:{}
        }
      },
       formSearch: {
        region: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    this.load()
  },
  computed:{},
  methods: {
    formatNumberWithCommas: formatNumberWithCommas,
    loadRegion(region) {
      this.formSearch.region = region
      this.load()
    },
    async load () {
      this.loading = true
      const rsp = await request.get('/api/stats/total', {
        ...this.formSearch,
      })
      this.loading = false
      for(let k in rsp.data) {
        this.stats_data[k] = rsp.data[k]
      }
    }
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.stats-table {
  
}
.stats-table td {
  border: 1px solid #BBB;
  padding: 4px 8px;
}
</style>